import { sortRowsArray, } from "@tedivo/tedivo-bay-grid-pure";
/** Returns all containers, sorted from Port to Stbd */
export function getAllContainersStbdSide(smartBay) {
    const { allStacksKeys } = smartBay.getGridContent();
    // Sorts from Port to Starboard. Therefore, the last containers drawn will be the ones on the starboard side, which is what we want to show in the side view of STBD.
    const allStackKeysSortd = allStacksKeys.slice().sort(sortRowsArray);
    return getAllContainers(smartBay, allStackKeysSortd);
}
export function getAllContainersPortSide(smartBay) {
    const { allStacksKeys } = smartBay.getGridContent();
    // Sorts from Starboard to Port. Therefore, the last containers drawn will be the ones on the Port side, which is what we want to show in the side view of PORT.
    const allStackKeysSortd = allStacksKeys.slice().sort(sortRowsArray).reverse();
    return getAllContainers(smartBay, allStackKeysSortd);
}
function getAllContainers(smartBay, allStackKeysSortd) {
    var _a;
    const containers = [];
    const { gridContent, allTiersKeys } = smartBay.getGridContent();
    for (const tierKey of allTiersKeys) {
        for (const stackKey of allStackKeysSortd) {
            const currContent = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tierKey];
            if (!currContent)
                continue;
            containers.push(...currContent.containers);
        }
    }
    return {
        containers,
        tBaysStr: smartBay.tBaysStr,
        level: smartBay.level,
    };
}
